<template>
    <div>
        <MainPage @clickBack="clickBack()" customClass="lg:max-w-xl">
            <div class="p-4 lg:px-12" v-if="delivery">
                <div class="w-full delivery-tab-hover relative">
                    <div class="absolute top-0 delivery-tab w-1/2 bg-a-red-d62300 rounded-full duration-700"
                        :class="{'left-0': delivery.deliveryMethod == 'Delivery','left-1/2': delivery.deliveryMethod == 'InStore'}"
                    ></div>
                    <div class="absolute top-0 flex w-full text-18 rounded-full overflow-hidden border border-a-red-d62300 cursor-pointer">
                        <div @click="clickDeliveryMethod('Delivery')"
                            class="w-1/2 text-center text-14 rounded-full py-1.5 text-a-red-d62300"
                            :class="{'text-a-egg-f5ebdc ': delivery.deliveryMethod == 'Delivery'}"
                            >{{lbl.deliverymethod.delivery}}</div>
                        <div @click="clickDeliveryMethod('InStore')"
                            class="w-1/2 text-center text-14 rounded-full py-1.5 text-a-red-d62300"
                            :class="{'text-a-egg-f5ebdc ': delivery.deliveryMethod == 'InStore'}"
                            >{{lbl.deliverymethod.self_pickup}}</div>
                    </div>
                </div>

                <Delivery v-if="delivery.deliveryMethod == 'Delivery'"
                    class="mt-4"
                    :address="delivery.address"
                ></Delivery>
                <Pickup v-if="delivery.deliveryMethod == 'InStore'"
                    class="mt-4"
                    :delivery="delivery">
                </Pickup>
                <SelectTime class="mt-4"
                    v-if="isLoaded"
                    :isShowSpecific="specificConfig > 0"
                    :limitDate="specificConfig"
                    :delivery="delivery"></SelectTime>
                <div class="px-14 py-6">
                    <RedButton @click="clickApply()">
                        {{lbl.deliverymethod.apply}}
                    </RedButton>
                </div>
            </div>
        </MainPage>
    </div>
</template>

<script>
import { nextTick } from 'vue';
import CacheHelper from '@/helper/CacheHelper'
import { CacheKey } from '@/helper/StaticValue'
import DeliveryHelper from "@/helper/DeliveryHelper.js";
import { DeliveryMethodModel } from '@/module/DeliveryMethod/model/DeliveryMethodModel.js';
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import Delivery from "../component/Delivery.vue";
import Pickup from "../component/Pickup.vue";
import SelectTime from "../component/SelectTime.vue";
import RedButton from "@/components/Button/RedButton.vue";
//service
import BKDeliveryMethod from "../service/BKDeliveryMethod";
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";
import BKCart from "../../ShoppingCart/service/BKCart"
import BzbsBlob from '@/core/Blob/service/BzbsBlob';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import DeliveryMixin from '@/mixin/DeliveryMixin';
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "DeliveryMethod",
    inject: ['CartCountStore'],
    mixins: [ModalMixin,DeliveryMixin,AuthStatusMixin,LocaleMixin],
    components: {
        MainPage,
        Delivery,
        Pickup,
        SelectTime,
        RedButton
    },
    data: function() {
        return {
            addressList: [],
            tempDelivery: null,
            specificConfig: 0,
            isLoaded: false
        };
    },
    created: async function() {
        this.tracking.event('homepage','view_delivery_method',null,null);
        this.initDeliveryMethod();
        this.getTempDelivery();
        let res = await this.getConfig();
        if (res) {
            this.specificConfig = res.delivery_method.future_order_max_days;
            if (this.specificConfig > 14) {
                this.specificConfig = 14;
            }
        } else {
            this.specificConfig = 0;
        }
        this.isLoaded = true;
    },
    mounted: function() {
        this.modal.loadingModal.show();
    },
    methods: {
        onAccountInit:  function() {
            if (this.isFromDeliveryMethod) {
                this.checkEditFromDeliveryMethod();
            }
        },
        checkEditFromDeliveryMethod: async function() {
            if (this.delivery.deliveryMethod == "Delivery" && this.delivery.address == null) {
                this.$router.push("/selectaddress");
            } else if (this.delivery.deliveryMethod == "InStore") {
                this.updateIsFromDeliveryMethod(false);
                this.$router.push("/selectbranch");
            } else {
                this.updateIsFromDeliveryMethod(false);
            }
        },
        getTempDelivery: function() {
            let cacheDelivery = DeliveryHelper.getCacheDelivery();
            this.tempDelivery = new DeliveryMethodModel();
            this.tempDelivery.setValueFormCache(cacheDelivery);
        },
        initDeliveryMethod: async function() {
            var isGetPermissionDelivery = await this.apiGetPermissionDelivery();
            if (isGetPermissionDelivery) {
                this.modal.loadingModal.hide();
            }
        },
        clickDeliveryMethod: async function(deliveryMethod) {
            this.delivery.deliveryMethod = deliveryMethod;
            this.isLoaded = false;
            if (this.delivery.deliveryMethod == "Delivery") {
                this.delivery.deliverTime = null;
                if (this.delivery.address == null) {
                    if (await this.apiGetAddressList()) {
                        if (this.addressList.length > 0) {
                            this.delivery.address = this.addressList[0];
                        }
                    }
                }
                nextTick(() => {
                    this.isLoaded = true;
                });
            } else {
                this.delivery.deliverTime = null;
                nextTick(() => {
                    this.isLoaded = true;
                });
            }
        },
        trackingEvent: function(){
            // Add Tracking Event
            let timeState = this.delivery.deliverTime != null ? 'specifictime' : 'now';

            if (this.delivery.deliveryMethod == "Delivery") {
                this.tracking.event('homepage','click_apply', `delivery||${timeState}`, null);
            }
            else{

                if(this.delivery.orderPlan == 'TakeOut'){
                    this.tracking.event('homepage','click_apply', `pickup|takeaway|${timeState}`, null);
                }
                else if(this.delivery.orderPlan == 'DineIn'){
                    this.tracking.event('homepage','click_apply', `pickup|dinein|${timeState}`, null);
                }
            }

        },
        clickApply: async function() {
            // Call Tracking Event
            this.trackingEvent();

            if (this.tempDelivery.deliveryMethod != this.delivery.deliveryMethod) {
                this.modal.confirmTwoButtonModal
                                    .clearModal()
                                    .setMsg(this.lbl.deliverymethod.popup_confirm_clear.msg)
                                    .setBtnOk(this.lbl.deliverymethod.popup_confirm_clear.ok)
                                    .setBtnCancel(this.lbl.deliverymethod.popup_confirm_clear.cancel)
                                    .show();
                this.modal.confirmTwoButtonModal.onClickOk(async () => {
                    if (await this.apiPostCartDelivery() && await this.apiDeleteCartItemAll()) {
                        this.CartCountStore.methods.updateCartCount();
                        // this.$router.back();
                        this.checkRedirect();
                    }
                })
            } else {
                if (await this.apiPostCartDelivery()) {
                    // this.$router.back();
                    this.checkRedirect();
                }
            }
        },
        checkRedirect: function() {
            let cache = new CacheHelper('session');
            let dataCache = cache.getCache(CacheKey.nav);
            if (dataCache) {
                cache.removeCache(CacheKey.nav);
                this.$router.push('/home');
            } else {
                this.$router.back();
            }
        },
        apiPostCartDelivery: async function() {
            return new Promise((resolve) => {
                var params = this.delivery.getParams();
                BKDeliveryMethod.apiPostCartDelivery(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.updateDelivery(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        if (err.code == 409 && err.id == 1403) {
                            err.message = this.lbl.deliverymethod.out_of_area;
                        }
                        this.errorApi(err);
                    },
                });
            });
        },
        apiGetPermissionDelivery: async function() {
            return new Promise((resolve) => {
                BKDeliveryMethod.apiGetPermissionDelivery().subscribe({
                    next: (data) => {
                        this.deliveryMethod = data
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiDeleteCartItemAll: async function() {
            return new Promise((resolve) => {
                BKCart.apiDeleteCartItemAll().subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiGetAddressList: function() {
            return new Promise((resolve) => {
                BzbsAddressList.apiGetAddressList().subscribe((addressList) => {
                    this.addressList = addressList;
                    resolve(true);
                }, (err) => {
                    resolve(false);
                    this.errorApi(err);
                });
            });
        },
        clickBack: function() {
            this.getDeliveryFromCache();
            this.$router.back();
        },
        getConfig: function() {
            let path = '/webconfig/burgerking/config.json';
            return new Promise((resolve) => {
                BzbsBlob.apiGetBlob(path).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    }
                });
            })
        }

    }
}
</script>

<style lang="scss" scoped>
    .delivery-tab-hover {
        height: 36px;
    }
    .delivery-tab {
        height: 35px;
    }
</style>
